(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/newstt/views/news-tt-error.js') >= 0) return;  svs.modules.push('/components/statistics/newstt/views/news-tt-error.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.statistics=_svs.statistics||{};
_svs.statistics.newstt=_svs.statistics.newstt||{};
_svs.statistics.newstt.templates=_svs.statistics.newstt.templates||{};
svs.statistics.newstt.templates.news_tt_error = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials["components-statistics-statistics-nodata"],(depth0 != null ? depth0.errorMessage : depth0),{"name":"components-statistics-statistics-nodata","data":data,"indent":"  ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.displayError : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['components-statistics-newstt-news_tt_error'] = svs.statistics.newstt.templates.news_tt_error;
})(svs, Handlebars);

 })(window);